import api from './api';

// Tareas / actividades / talleres
const getTasks = async (classroomId) => {
    try {
        const response = await api.get(`/classroom-task/classroom/${classroomId}`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const getTask = async (taskId) => {
    try {
        const response = await api.get(`/classroom-task/${taskId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const createTask = async (taskData) => {
    try {
        const response = await api.post(`/classroom-task`, taskData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const updateTask = async (taskData) => {
    try {
        const response = await api.put(`/classroom-task`, taskData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const deleteTask = async (taskId) => {
    try {
        const response = await api.delete(`/classroom-task/${taskId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Entregas
const getSubmission = async (submissionId) => {
    try {
        const response = await api.get(`/classroom-task/submission/${submissionId}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getSubmissionsForStudent = async (taskId, studentId) => {
    try {
        const response = await api.get(`/classroom-task/${taskId}/student/${studentId}/submissions`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

const submitTask = async (submissionData) => {
    try {
        const response = await api.post(`/classroom-task/submission`, submissionData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const returnSubmission = async (submissionId, modificationUser) => {
    try {
        const response = await api.post(`/classroom-task/submission/${submissionId}/return`, { modificationUser });
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Notas
const getGradeForStudent = async (taskId, studentId) => {
    try {
        const response = await api.get(`/classroom-task/${taskId}/student/${studentId}/grade`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return null;
        throw error;
    }
};

const saveGrade = async (gradeData) => {
    try {
        const response = await api.post(`/classroom-task/grade`, gradeData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Requisito 5: listado de estudiantes matriculados con su entrega y su nota
const getRoster = async (taskId) => {
    try {
        const response = await api.get(`/classroom-task/${taskId}/roster`);
        return response.data;
    } catch (error) {
        if (error?.response?.status === 204) return [];
        throw error;
    }
};

export default {
    getTasks,
    getTask,
    createTask,
    updateTask,
    deleteTask,
    getSubmission,
    getSubmissionsForStudent,
    submitTask,
    returnSubmission,
    saveGrade,
    getGradeForStudent,
    getRoster
};
